import { z } from 'zod';

import { MiceChosenFlightSchema } from './mice_needs';
import { IataSchema, MiceMoneySchema, MiceSuggestedFlightSchema } from './mice_refs';

/** Situação de uma linha do orçamento do evento. */
export const MICE_BUDGET_SITUATIONS = [
  'quoted',
  'cadastro_pending',
  'no_solution',
  'quoting',
  'excluded',
] as const;
export const MiceBudgetSituationSchema = z.enum(MICE_BUDGET_SITUATIONS);
export type MiceBudgetSituation = z.infer<typeof MiceBudgetSituationSchema>;

/** Um sentido cotado: o voo escolhido e a tarifa. */
export const MiceBudgetLegSchema = z.object({
  flight: MiceChosenFlightSchema.nullable(),
  fare: MiceMoneySchema.nullable(),
});
export type MiceBudgetLeg = z.infer<typeof MiceBudgetLegSchema>;

export const MiceBudgetRowSchema = z.object({
  needId: z.string(),
  name: z.string().nullable(),
  email: z.string(),
  origin: IataSchema.nullable(),
  /** O que a agência pôs na planilha. */
  sheet: z.object({
    outbound: MiceSuggestedFlightSchema.nullable(),
    inbound: MiceSuggestedFlightSchema.nullable(),
    outboundFare: MiceMoneySchema.nullable(),
    inboundFare: MiceMoneySchema.nullable(),
  }),
  /** O que a cotação da VOLL escolheu. */
  quoted: z.object({ outbound: MiceBudgetLegSchema, inbound: MiceBudgetLegSchema }),
  total: MiceMoneySchema.nullable(),
  savings: MiceMoneySchema.nullable(),
  quotedAt: z.iso.datetime().nullable(),
  situation: MiceBudgetSituationSchema,
  note: z.string().nullable(),
});
export type MiceBudgetRow = z.infer<typeof MiceBudgetRowSchema>;

export const MiceBudgetViewSchema = z.object({
  requestedAt: z.iso.datetime().nullable(),
  quoting: z.object({ done: z.number().int(), total: z.number().int() }),
  total: MiceMoneySchema.nullable(),
  savings: MiceMoneySchema.nullable(),
  /** Totais por origem; '—' agrupa quem não tem origem. */
  byOrigin: z.array(
    z.object({
      origin: z.union([IataSchema, z.literal('—')]),
      travelers: z.number().int(),
      amount: z.number(),
      savings: z.number(),
      /** A moeda de referência do orçamento: vale mesmo quando o total é nulo (moedas misturadas). */
      currency: z.string().default('BRL'),
    }),
  ),
  quotedRange: z.object({ from: z.iso.datetime(), to: z.iso.datetime() }).nullable(),
  rows: z.array(MiceBudgetRowSchema),
});
export type MiceBudgetView = z.infer<typeof MiceBudgetViewSchema>;
